import React from "react";
import { useNavigate } from "react-router-dom";

const CustomPaymentPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
      <div className="max-w-lg w-full bg-[#0d0d0d] border border-[#0099f2] rounded-xl p-8 text-center">
        <h1 className="text-2xl font-semibold mb-4">Custom Payment</h1>
        <p className="text-sm text-[#bfc5c5] mb-6">
          This page is a placeholder for custom payment flows. Click the button
          below to open the standard payment page.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            className="px-4 py-2 bg-[#0099f2] rounded text-white font-medium"
            onClick={() => navigate("/payment")}
          >
            Proceed to Payment
          </button>
          <button
            className="px-4 py-2 border border-white rounded text-white"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomPaymentPage;
